export default {
  number: ({
    min,
    max,
  }: {
    min: number | null | undefined;
    max: number | null | undefined;
  }) => {
    if (!isNumber(min) && !isNumber(max)) return "";
    else if (isNumber(min) && !isNumber(max)) {
      return `Min ${min}y`;
    } else if (!isNumber(min) && isNumber(max)) return `Max ${max}y`;
    else return `${min}-${max} y`;
  },
};

const isNumber = (value: number | null | undefined) =>
  typeof value === "number";
